import React from "react";

export default function EmailLogs(props) {
  return (
    <div className="my-3">
      <h3 className="email-logs-title">Email Logs: {props.id}</h3>
      <div className="table-container">
        <table className="table email-logs-table">
          <thead>
            <tr>
              <th>Date</th>
              <th>Subject</th>
              <th>Status</th>
            </tr>
          </thead>
          {/* <tbody>
            {customerData.emailLogs && customerData.emailLogs.length > 0 ? (
              customerData.emailLogs.map((log, index) => (
                <tr key={index}>
                  <td>{log.date}</td>
                  <td>{log.subject}</td>
                  <td>{log.status}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="3" className="no-logs">
                  No email logs available
                </td>
              </tr>
            )}
          </tbody> */}
        </table>
      </div>
    </div>
  );
}
